import Vue from 'vue';
import VueRouter from 'vue-router';
import Welcome from '@/views/Welcome.vue';
import Login from '@/views/Login.vue';
import GettingReady from '@/views/GettingReady.vue';
import ErrorPage from '@/views/ErrorPage.vue';
import UserDetails from '@/views/UserDetails.vue';
import Interview from '@/views/Interview.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/welcome'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      shouldBeLoggedOut: true
    }
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    meta: {
      shouldBeLoggedOut: true
    }
  },
  {
    path: '/getting_ready',
    name: 'GettingReady',
    component: GettingReady,
    meta: {
      requiresAuth: true
    },
    beforeEnter: async (to, from, next) => {
      // Go to getting ready while we wait
      next();

      // Watch for get employee
      const gettingReadyUnwatch = store.watch(
        (state, getters) => getters.hasEmployeeData,
        () => {
          // Reroute to relevant page according to info status
          if (store.getters.isEmployeeCompleted === true) {
            next({ name: 'Interview' });
          } else if (store.state.employeeData != null) {
            next({ name: 'UserDetails' });
          }

          // Do not reroute again on future changes
          gettingReadyUnwatch();
        }
      );

      // Get employee
      try {
        await store.dispatch('requestEmployee');
      } catch (error) {
        next({ name: 'Error' });
        gettingReadyUnwatch();
      }
    }
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorPage,
    beforeEnter: (to, from, next) => {
      if (from.name === null) {
        next({ name: 'GettingReady' });
      } else {
        next();
      }
    }
  },
  {
    path: '/userdetails',
    name: 'UserDetails',
    component: UserDetails,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.hasEmployeeData === true) {
        if (store.getters.isEmployeeCompleted === true) {
          next({ name: 'Interview' });
        } else {
          next();
        }
      } else {
        next({ name: 'GettingReady' });
      }
    }
  },
  {
    path: '/interview',
    name: 'Interview',
    component: Interview,
    meta: {
      requiresAuth: true
    },
    beforeEnter: async (to, from, next) => {
      if (store.getters.hasEmployeeData === true) {
        next();
      } else {
        next({ name: 'GettingReady' });
      }
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () =>
      import(
        /* webpackChunkName: "privacypolicy" */ '../views/PrivacyPolicy.vue'
      )
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
